import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';
import { withDefaultSort } from '../../utils/utility';

export const ACTION = {
  LIST: 'LIST_LUMINAIRE',
  GET: 'GET_LUMINAIRE',
  CREATE: 'CREATE_LUMINAIRE',
  EDIT: 'EDIT_LUMINAIRE',
  DELETE: 'DELETE_LUMINAIRE',
  DUPLICATE: 'DUPLICATE_LUMINAIRE',
  CLEAR_ERROR: 'CLEAR_ERROR_LUMINAIRE',
};

export const clearErrorLuminanire = () => {
  return {
    type: ACTION.CLEAR_ERROR,
  };
};

const fetchLuminaireItems = (pageSize, page, sorted, filtered, isPublic) => {
  return RestClient.request({
    method: 'get',
    url: Constants.API_BULB,
    params: {
      search: filtered,
      limit: pageSize,
      offset: pageSize * page,
      ordering: sorted
        ? sorted.map(sort => sort.desc ? `-${sort.id}` : sort.id ).join(',')
        : null,
      is_public: isPublic,
    },
  });
};

export const searchLuminanireByText = (text, page) => {
  const pageSize = Constants.DATA_TABLE_PAGE_SIZE;
  const sorted = withDefaultSort([]);
  const filtered = null;
  const isPublic = null;

  return fetchLuminaireItems(pageSize, page, sorted, filtered, isPublic)
    .catch(err => Promise.reject(err.response.data.detail));
};

export const listLuminaireItems = (pageSize, page, sorted, filtered, isPublic) => {
  return {
    type: ACTION.LIST,
    payload: fetchLuminaireItems(pageSize, page, sorted, filtered, isPublic)
      .catch(err => Promise.reject(err.response.data.detail)),
  };
};

export const getLuminaire = (id) => {
  return {
    type: ACTION.GET,
    payload: RestClient.request({
      method: 'get',
      url: `${Constants.API_BULB}${id}/`,
    }).catch(err => Promise.reject(err.response.data.detail)),
  };
};

export const createLuminaireItem = (name, brand_id, type_id, power_required, description, image, cfpValue, cfpUnit) => {
  const formData = new FormData();
  formData.set('name', name);
  formData.set('brand_id', brand_id);
  formData.set('type_id', type_id);
  formData.set('power_required', power_required);
  formData.set('description', description);
  if (cfpValue !== undefined && cfpValue !== null && cfpValue !== '') formData.set('cfp_value', cfpValue);
  if (cfpUnit) formData.set('cfp_unit', cfpUnit);
  if (image) formData.set('image', image, `photovoltaic_${new Date().valueOf()}`);

  return {
    type: ACTION.CREATE,
    payload: RestClient.request({
      method: 'post',
      url: Constants.API_BULB,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const editLuminaire = (id, name, brand_id, type_id, power_required, description, image, cfpValue, cfpUnit) => {
  const formData = new FormData();
  if (name) formData.set('name', name);
  if (brand_id) formData.set('brand_id', brand_id);
  if (type_id) formData.set('type_id', type_id);
  if (power_required) formData.set('power_required', power_required);
  if (typeof(description) === 'string') formData.set('description', description);
  if (cfpValue !== undefined && cfpValue !== null && cfpValue !== '') formData.set('cfp_value', cfpValue);
  if (cfpUnit) formData.set('cfp_unit', cfpUnit);
  if (image) formData.set('image', image, `equipment_${new Date().valueOf()}`);

  return {
    type: ACTION.EDIT,
    payload: RestClient.request({
      method: 'patch',
      url: `${Constants.API_BULB}${id}/`,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const deleteLuminaire = luminaireId => {
  return {
    type: ACTION.DELETE,
    payload: RestClient.request({
      method: 'delete',
      url: `${Constants.API_BULB}${luminaireId}/`,
    })
      .then(() => ({ id: luminaireId }))
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const duplicateLuminaire = (id, name) => {
  const data = { new_name: name };
  return {
    type: ACTION.DUPLICATE,
    payload: RestClient.request({
      method: 'post',
      url: `${Constants.API_BULB}${id}/copy/`,
      data,
    }).catch(err => Promise.reject(err.response.data)),
  };
};



// WEBPACK FOOTER //
// ./src/redux/luminaire/luminaire_actions.js